import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { sessionKeys } from './sessionKeys';

export function useDeleteSession() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (sessionId: string) =>
      apiClient.delete(`api/v1/t/${tenantId}/sessions/${sessionId}`).then(() => undefined),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: sessionKeys.lists() });
    },
  });
}
